import styled from '@emotion/styled';

export const TurbineStatusChartBase = styled.div`
    background-color: ${(p) => p.theme.color.grayDark3};
    width: 100%;
`;
